import { Avatar, Button, Link, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import {
  B2CBackground,
  B2CLoginError,
  B2CMobileLogo,
  LeftArrow,
  PurpleOutlineWarningIcon,
  RightArrowDatePicker,
} from 'Images';

export const MobileUI = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.B2C);

  const onClickBack = () => {
    window.location.assign('/');
  };

  const onClickInfo = () => {
    window.location.assign('https://shikum.mod.gov.il/recognition/request');
  };

  return (
    <Stack>
      <Stack
        sx={{
          p: '8px 16px 135px',
          backgroundImage: `url(${B2CBackground})`,
          backgroundSize: 'cover',
        }}
      >
        <Stack sx={{ gap: '4px', alignItems: 'center', width: 'fit-content' }}>
          <Avatar
            alt=''
            src={B2CMobileLogo}
            sx={{ width: '32px', height: '33.3px' }}
          />
          <Typography sx={{ fontSize: '14px', fontWeight: '500' }}>
            {dictionary.logo}
          </Typography>
        </Stack>
      </Stack>
      <Stack
        sx={{
          m: '-86px 0 135px',
          bgcolor: 'white',
          height: '100%',
          borderTopRightRadius: '24px',
          borderBottomRightRadius: '24px',
          alignItems: 'center',
        }}
      >
        <Avatar
          alt=''
          src={B2CLoginError}
          sx={{ width: '142px', height: '97px', mt: '-54px' }}
        />
        <Typography
          sx={{
            fontSize: '28px !important',
            fontWeight: '700',
            mt: '16px',
          }}
          component='h1'
        >
          {dictionary.errorTitleMobile}
        </Typography>
        <Typography mt='24px' variant='body3'>
          {dictionary.errorExplanation.line1}
        </Typography>
        <Typography variant='body3'>
          {dictionary.errorExplanation.line2}
        </Typography>
        <Stack
          sx={{ flexDirection: 'row', justifyContent: 'center', gap: '6px' }}
        >
          <Typography variant='body3'>
            {dictionary.errorExplanation.line3}
          </Typography>
          <Typography variant='body3' sx={{ color: '#1552E8' }}>
            {dictionary.errorExplanation.phoneNumber}
          </Typography>
        </Stack>
        <Button
          variant='outlined'
          sx={{
            width: '244px',
            height: '46px',
            mt: '40px',
            alignItems: 'center',
          }}
          onClick={onClickBack}
        >
          <Avatar
            alt=''
            src={RightArrowDatePicker}
            sx={{ width: '26px', height: '26px ' }}
          />
          <Typography variant='body4'>{dictionary.buttonLabel}</Typography>
        </Button>
        <Stack
          sx={{
            flexDirection: 'row',
            gap: '8px',
            alignItems: 'flex-start',
            mt: '121px',
            p: '0 24px',
          }}
        >
          <Avatar
            alt=''
            src={PurpleOutlineWarningIcon}
            sx={{ width: '16px', height: '16px' }}
          />
          <Typography variant='body5'>
            {dictionary.helpTextLeft.line1Mobile}
          </Typography>
        </Stack>
        <Stack
          sx={{
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '6px',
            mt: '16px',
          }}
        >
          <Link onClick={onClickInfo} underline='none'>
            <Stack sx={{ flexDirection: 'row', alignItems: 'center' }}>
              <Typography variant='body6'>
                {`${dictionary.helpTextLeft.line2} ${dictionary.helpTextLeft.link}`}
              </Typography>
              <Avatar
                alt=''
                src={LeftArrow}
                sx={{ width: '26px', height: '26px ' }}
              />
            </Stack>
          </Link>
        </Stack>
      </Stack>
    </Stack>
  );
};
